/**
 * 国际国家数据。
 * 数据来源：biz_internation_country_code 的最新数据，仅使用数据库 country_id。
 */
export const countries = [
  { countryId: 155, nameCh: '阿尔巴尼亚', nameEn: 'Albania' },
  { countryId: 58, nameCh: '阿尔及利亚', nameEn: 'Algeria' },
  { countryId: 74, nameCh: '阿富汗', nameEn: 'Afghanistan' },
  { countryId: 39, nameCh: '阿根廷', nameEn: 'Argentina' },
  { countryId: 95, nameCh: '阿联酋', nameEn: 'United Arab Emirates' },
  { countryId: 179, nameCh: '阿鲁巴', nameEn: 'Aruba' },
  { countryId: 107, nameCh: '阿曼', nameEn: 'Oman' },
  { countryId: 35, nameCh: '阿塞拜疆', nameEn: 'Azerbaijan' },
  { countryId: 21, nameCh: '埃及', nameEn: 'Egypt' },
  { countryId: 71, nameCh: '埃塞俄比亚', nameEn: 'Ethiopia' },
  { countryId: 23, nameCh: '爱尔兰', nameEn: 'Ireland' },
  { countryId: 34, nameCh: '爱沙尼亚', nameEn: 'Estonia' },
  { countryId: 76, nameCh: '安哥拉', nameEn: 'Angola' },
  { countryId: 181, nameCh: '安圭拉', nameEn: 'Anguilla' },
  { countryId: 169, nameCh: '安提瓜和巴布达', nameEn: 'Antigua and Barbuda' },
  { countryId: 50, nameCh: '奥地利', nameEn: 'Austria' },
  { countryId: 175, nameCh: '澳大利亚', nameEn: 'Australia' },
  { countryId: 20, nameCh: '澳门', nameEn: 'Macau' },
  { countryId: 118, nameCh: '巴巴多斯', nameEn: 'Barbados' },
  { countryId: 79, nameCh: '巴布亚新几内亚', nameEn: 'Papua New Guinea' },
  { countryId: 122, nameCh: '巴哈马', nameEn: 'Bahamas' },
  { countryId: 66, nameCh: '巴基斯坦', nameEn: 'Pakistan' },
  { countryId: 87, nameCh: '巴拉圭', nameEn: 'Paraguay' },
  { countryId: 188, nameCh: '巴勒斯坦', nameEn: 'Palestine' },
  { countryId: 145, nameCh: '巴林', nameEn: 'Bahrain' },
  { countryId: 112, nameCh: '巴拿马', nameEn: 'Panama' },
  { countryId: 73, nameCh: '巴西', nameEn: 'Brazil' },
  { countryId: 51, nameCh: '白俄罗斯', nameEn: 'Belarus' },
  { countryId: 1003, nameCh: '百慕大', nameEn: 'Bermuda' },
  { countryId: 83, nameCh: '保加利亚', nameEn: 'Bulgaria' },
  { countryId: 120, nameCh: '贝宁', nameEn: 'Benin' },
  { countryId: 82, nameCh: '比利时', nameEn: 'Belgium' },
  { countryId: 132, nameCh: '冰岛', nameEn: 'Iceland' },
  { countryId: 97, nameCh: '波多黎各', nameEn: 'Puerto Rico' },
  { countryId: 15, nameCh: '波兰', nameEn: 'Poland' },
  { countryId: 108, nameCh: '波斯尼亚和黑塞哥维那', nameEn: 'Bosnia and Herzegovina' },
  { countryId: 92, nameCh: '玻利维亚', nameEn: 'Bolivia' },
  { countryId: 124, nameCh: '伯利兹', nameEn: 'Belize' },
  { countryId: 123, nameCh: '博茨瓦纳', nameEn: 'Botswana' },
  { countryId: 158, nameCh: '不丹', nameEn: 'Bhutan' },
  { countryId: 152, nameCh: '布基纳法索', nameEn: 'Burkina Faso' },
  { countryId: 119, nameCh: '布隆迪', nameEn: 'Burundi' },
  { countryId: 167, nameCh: '赤道几内亚', nameEn: 'Equatorial Guinea' },
  { countryId: 172, nameCh: '丹麦', nameEn: 'Denmark' },
  { countryId: 43, nameCh: '德国', nameEn: 'Germany' },
  { countryId: 91, nameCh: '东帝汶', nameEn: 'Timor-Leste' },
  { countryId: 99, nameCh: '多哥', nameEn: 'Togo' },
  { countryId: 126, nameCh: '多米尼加', nameEn: 'Dominica' },
  { countryId: 109, nameCh: '多米尼加共和国', nameEn: 'Dominican Republic' },
  { countryId: 0, nameCh: '俄罗斯联邦', nameEn: 'Russian Federation' },
  { countryId: 105, nameCh: '厄瓜多尔', nameEn: 'Ecuador' },
  { countryId: 176, nameCh: '厄立特里亚', nameEn: 'Eritrea' },
  { countryId: 78, nameCh: '法国', nameEn: 'France' },
  { countryId: 162, nameCh: '法属圭亚那', nameEn: 'French Guiana' },
  { countryId: 4, nameCh: '菲律宾', nameEn: 'Philippines' },
  { countryId: 189, nameCh: '斐济', nameEn: 'Fiji' },
  { countryId: 163, nameCh: '芬兰', nameEn: 'Finland' },
  { countryId: 186, nameCh: '佛得角', nameEn: 'Cape Verde' },
  { countryId: 28, nameCh: '冈比亚', nameEn: 'Gambia' },
  { countryId: 150, nameCh: '刚果', nameEn: 'Congo' },
  { countryId: 18, nameCh: '刚果（民主共和国）', nameEn: 'Democratic Republic of the Congo' },
  { countryId: 33, nameCh: '哥伦比亚', nameEn: 'Colombia' },
  { countryId: 93, nameCh: '哥斯达黎加', nameEn: 'Costa Rica' },
  { countryId: 127, nameCh: '格林纳达', nameEn: 'Grenada' },
  { countryId: 1008, nameCh: '格陵兰', nameEn: 'Greenland' },
  { countryId: 128, nameCh: '格鲁吉亚', nameEn: 'Georgia' },
  { countryId: 113, nameCh: '古巴', nameEn: 'Cuba' },
  { countryId: 131, nameCh: '古亚那', nameEn: 'Guyana' },
  { countryId: 160, nameCh: '瓜德罗普', nameEn: 'Guadeloupe' },
  { countryId: 2, nameCh: '哈萨克斯坦', nameEn: 'Kazakhstan' },
  { countryId: 26, nameCh: '海地', nameEn: 'Haiti' },
  { countryId: 1002, nameCh: '韩国', nameEn: 'South Korea' },
  { countryId: 48, nameCh: '荷兰', nameEn: 'Netherlands' },
  { countryId: 171, nameCh: '黑山', nameEn: 'Montenegro' },
  { countryId: 88, nameCh: '洪都拉斯', nameEn: 'Honduras' },
  { countryId: 168, nameCh: '吉布提', nameEn: 'Djibouti' },
  { countryId: 11, nameCh: '吉尔吉斯斯坦', nameEn: 'Kyrgyzstan' },
  { countryId: 68, nameCh: '几内亚', nameEn: 'Guinea' },
  { countryId: 130, nameCh: '几内亚比绍', nameEn: 'Guinea-Bissau' },
  { countryId: 36, nameCh: '加拿大', nameEn: 'Canada' },
  { countryId: 38, nameCh: '加纳', nameEn: 'Ghana' },
  { countryId: 154, nameCh: '加蓬', nameEn: 'Gabon' },
  { countryId: 24, nameCh: '柬埔寨', nameEn: 'Cambodia' },
  { countryId: 63, nameCh: '捷克共和国', nameEn: 'Czech Republic' },
  { countryId: 96, nameCh: '津巴布韦', nameEn: 'Zimbabwe' },
  { countryId: 41, nameCh: '喀麦隆', nameEn: 'Cameroon' },
  { countryId: 111, nameCh: '卡塔尔', nameEn: 'Qatar' },
  { countryId: 170, nameCh: '开曼群岛', nameEn: 'Cayman Islands' },
  { countryId: 133, nameCh: '科摩罗', nameEn: 'Comoros' },
  { countryId: 1004, nameCh: '科索沃', nameEn: 'Kosovo' },
  { countryId: 27, nameCh: '科特迪瓦', nameEn: 'Côte d\'Ivoire' },
  { countryId: 100, nameCh: '科威特', nameEn: 'Kuwait' },
  { countryId: 45, nameCh: '克罗地亚', nameEn: 'Croatia' },
  { countryId: 8, nameCh: '肯尼亚', nameEn: 'Kenya' },
  { countryId: 49, nameCh: '拉脱维亚', nameEn: 'Latvia' },
  { countryId: 136, nameCh: '莱索托', nameEn: 'Lesotho' },
  { countryId: 25, nameCh: '老挝人民', nameEn: 'Laos' },
  { countryId: 153, nameCh: '黎巴嫩', nameEn: 'Lebanon' },
  { countryId: 44, nameCh: '立陶宛', nameEn: 'Lithuania' },
  { countryId: 135, nameCh: '利比里亚', nameEn: 'Liberia' },
  { countryId: 102, nameCh: '利比亚', nameEn: 'Libya' },
  { countryId: 1005, nameCh: '列支敦士登', nameEn: 'Liechtenstein' },
  { countryId: 146, nameCh: '留尼汪岛', nameEn: 'Reunion' },
  { countryId: 165, nameCh: '卢森堡', nameEn: 'Luxembourg' },
  { countryId: 140, nameCh: '卢旺达', nameEn: 'Rwanda' },
  { countryId: 32, nameCh: '罗马尼亚', nameEn: 'Romania' },
  { countryId: 17, nameCh: '马达加斯加', nameEn: 'Madagascar' },
  { countryId: 159, nameCh: '马尔代夫', nameEn: 'Maldives' },
  { countryId: 199, nameCh: '马耳他', nameEn: 'Malta' },
  { countryId: 137, nameCh: '马拉维', nameEn: 'Malawi' },
  { countryId: 7, nameCh: '马来西亚', nameEn: 'Malaysia' },
  { countryId: 69, nameCh: '马里', nameEn: 'Mali' },
  { countryId: 183, nameCh: '马其顿', nameEn: 'North Macedonia' },
  { countryId: 1011, nameCh: '马提尼克', nameEn: 'Martinique' },
  { countryId: 157, nameCh: '毛里求斯', nameEn: 'Mauritius' },
  { countryId: 114, nameCh: '毛里塔尼亚', nameEn: 'Mauritania' },
  { countryId: 187, nameCh: '美国', nameEn: 'United States' },
  { countryId: 12, nameCh: '美国（虚拟）', nameEn: 'United States (Virtual)' },
  { countryId: 72, nameCh: '蒙古', nameEn: 'Mongolia' },
  { countryId: 180, nameCh: '蒙特塞拉特', nameEn: 'Montserrat' },
  { countryId: 60, nameCh: '孟加拉国', nameEn: 'Bangladesh' },
  { countryId: 65, nameCh: '秘鲁', nameEn: 'Peru' },
  { countryId: 5, nameCh: '缅甸', nameEn: 'Myanmar' },
  { countryId: 85, nameCh: '摩尔多瓦共和国', nameEn: 'Moldova' },
  { countryId: 37, nameCh: '摩洛哥', nameEn: 'Morocco' },
  { countryId: 144, nameCh: '摩纳哥', nameEn: 'Monaco' },
  { countryId: 80, nameCh: '莫桑比克', nameEn: 'Mozambique' },
  { countryId: 54, nameCh: '墨西哥', nameEn: 'Mexico' },
  { countryId: 138, nameCh: '纳米比亚', nameEn: 'Namibia' },
  { countryId: 31, nameCh: '南非', nameEn: 'South Africa' },
  { countryId: 177, nameCh: '南苏丹', nameEn: 'South Sudan' },
  { countryId: 90, nameCh: '尼加拉瓜', nameEn: 'Nicaragua' },
  { countryId: 81, nameCh: '尼泊尔', nameEn: 'Nepal' },
  { countryId: 139, nameCh: '尼日尔', nameEn: 'Niger' },
  { countryId: 19, nameCh: '尼日利亚', nameEn: 'Nigeria' },
  { countryId: 174, nameCh: '挪威', nameEn: 'Norway' },
  { countryId: 117, nameCh: '葡萄牙', nameEn: 'Portugal' },
  { countryId: 1001, nameCh: '日本', nameEn: 'Japan' },
  { countryId: 46, nameCh: '瑞典', nameEn: 'Sweden' },
  { countryId: 173, nameCh: '瑞士', nameEn: 'Switzerland' },
  { countryId: 101, nameCh: '萨尔瓦多', nameEn: 'El Salvador' },
  { countryId: 29, nameCh: '塞尔维亚', nameEn: 'Serbia' },
  { countryId: 115, nameCh: '塞拉利昂', nameEn: 'Sierra Leone' },
  { countryId: 61, nameCh: '塞内加尔', nameEn: 'Senegal' },
  { countryId: 77, nameCh: '塞浦路斯', nameEn: 'Cyprus' },
  { countryId: 184, nameCh: '塞舌尔', nameEn: 'Seychelles' },
  { countryId: 53, nameCh: '沙特阿拉伯', nameEn: 'Saudi Arabia' },
  { countryId: 178, nameCh: '圣多美和普林西比', nameEn: 'Sao Tome and Principe' },
  { countryId: 134, nameCh: '圣基茨和尼维斯', nameEn: 'Saint Kitts and Nevis' },
  { countryId: 164, nameCh: '圣卢西亚', nameEn: 'Saint Lucia' },
  { countryId: 1006, nameCh: '圣马丁岛', nameEn: 'Sint Maarten' },
  { countryId: 166, nameCh: '圣文森特', nameEn: 'Saint Vincent' },
  { countryId: 64, nameCh: '斯里兰卡', nameEn: 'Sri Lanka' },
  { countryId: 141, nameCh: '斯洛伐克', nameEn: 'Slovakia' },
  { countryId: 59, nameCh: '斯洛文尼亚', nameEn: 'Slovenia' },
  { countryId: 106, nameCh: '斯威士兰', nameEn: 'Eswatini' },
  { countryId: 1010, nameCh: '苏丹', nameEn: 'Sudan' },
  { countryId: 142, nameCh: '苏里南', nameEn: 'Suriname' },
  { countryId: 149, nameCh: '索马里', nameEn: 'Somalia' },
  { countryId: 143, nameCh: '塔吉克斯坦', nameEn: 'Tajikistan' },
  { countryId: 55, nameCh: '台湾', nameEn: 'Taiwan' },
  { countryId: 52, nameCh: '泰国', nameEn: 'Thailand' },
  { countryId: 9, nameCh: '坦桑尼亚', nameEn: 'Tanzania' },
  { countryId: 104, nameCh: '特立尼达和多巴哥', nameEn: 'Trinidad and Tobago' },
  { countryId: 89, nameCh: '突尼斯', nameEn: 'Tunisia' },
  { countryId: 62, nameCh: '土耳其', nameEn: 'Turkey' },
  { countryId: 161, nameCh: '土库曼斯坦', nameEn: 'Turkmenistan' },
  { countryId: 1007, nameCh: '瓦努阿图', nameEn: 'Vanuatu' },
  { countryId: 94, nameCh: '危地马拉', nameEn: 'Guatemala' },
  { countryId: 70, nameCh: '委内瑞拉', nameEn: 'Venezuela' },
  { countryId: 121, nameCh: '文莱达鲁萨兰国', nameEn: 'Brunei Darussalam' },
  { countryId: 75, nameCh: '乌干达', nameEn: 'Uganda' },
  { countryId: 1, nameCh: '乌克兰', nameEn: 'Ukraine' },
  { countryId: 156, nameCh: '乌拉圭', nameEn: 'Uruguay' },
  { countryId: 40, nameCh: '乌兹别克斯坦', nameEn: 'Uzbekistan' },
  { countryId: 56, nameCh: '西班牙', nameEn: 'Spain' },
  { countryId: 129, nameCh: '希腊', nameEn: 'Greece' },
  { countryId: 14, nameCh: '香港', nameEn: 'Hong Kong' },
  { countryId: 196, nameCh: '新加坡', nameEn: 'Singapore' },
  { countryId: 185, nameCh: '新喀里多尼亚', nameEn: 'New Caledonia' },
  { countryId: 67, nameCh: '新西兰', nameEn: 'New Zealand' },
  { countryId: 84, nameCh: '匈牙利', nameEn: 'Hungary' },
  { countryId: 1333, nameCh: '叙利亚阿拉伯共和国', nameEn: 'Syrian Arab Republic' },
  { countryId: 103, nameCh: '牙买加', nameEn: 'Jamaica' },
  { countryId: 148, nameCh: '亚美尼亚', nameEn: 'Armenia' },
  { countryId: 30, nameCh: '也门', nameEn: 'Yemen' },
  { countryId: 47, nameCh: '伊拉克', nameEn: 'Iraq' },
  { countryId: 57, nameCh: '伊朗', nameEn: 'Iran' },
  { countryId: 13, nameCh: '以色列', nameEn: 'Israel' },
  { countryId: 86, nameCh: '意大利', nameEn: 'Italy' },
  { countryId: 22, nameCh: '印度', nameEn: 'India' },
  { countryId: 6, nameCh: '印度尼西亚', nameEn: 'Indonesia' },
  { countryId: 16, nameCh: '英国', nameEn: 'United Kingdom' },
  { countryId: 116, nameCh: '约旦', nameEn: 'Jordan' },
  { countryId: 10, nameCh: '越南', nameEn: 'Vietnam' },
  { countryId: 147, nameCh: '赞比亚', nameEn: 'Zambia' },
  { countryId: 42, nameCh: '乍得', nameEn: 'Chad' },
  { countryId: 151, nameCh: '智利', nameEn: 'Chile' },
  { countryId: 125, nameCh: '中非共和国', nameEn: 'Central African Republic' },
  { countryId: 3, nameCh: '中国', nameEn: 'China' },
  { countryId: 201, nameCh: 'Gibraltar', nameEn: 'Gibraltar' },
  { countryId: 204, nameCh: 'Niue', nameEn: 'Niue' }
]

/**
 * 按数据库 country_id、中文名或英文名搜索国家。
 */
export function searchCountries(keyword) {
  if (!keyword) return countries

  const lowerKeyword = keyword.toLowerCase()
  return countries.filter(country =>
    country.nameCh.includes(keyword) ||
    country.nameEn.toLowerCase().includes(lowerKeyword) ||
    String(country.countryId).includes(keyword)
  )
}

/**
 * 根据数据库 country_id 获取国家信息。
 */
export function getCountryById(countryId) {
  return countries.find(country => String(country.countryId) === String(countryId))
}

// 保留旧函数名，兼容现有调用方；参数现在按数据库 country_id 处理。
export function getCountryByCode(countryId) {
  return getCountryById(countryId)
}
